import { ChatDateProps } from './chatDate.types';

const ChatDate: React.FC<ChatDateProps> = ({ date }) => {
  // Deliberately NOT position: sticky. Each date group here typically has exactly one
  // divider for the whole conversation (most threads only ever span "Today"), so a sticky
  // pill has no next group to get pushed out by -- it just floats at a fixed offset for the
  // entire scroll range and lands directly on top of message text once the user scrolls past
  // the first screen. A normal in-flow divider avoids that entirely.
  return (
    <div
      className="mx-auto mb-4 flex w-32 items-center justify-center rounded-full border border-gray bg-gray-100 px-10 py-1 text-center text-mSm font-bold text-gray"
      data-testid="messages_date_title"
    >
      {date === new Date().toDateString() ? 'Today' : new Date(date).toLocaleDateString()}
    </div>
  );
};

export default ChatDate;
